export default class SearchState {
  value = '';
  constructor(cachedSearches) {
    if (cachedSearches === void 0) {
      cachedSearches = [];
    }
    this.cachedSearches = new Set(cachedSearches);
  }

  /**
   * If we are displaying the full results of a search (not just a preview),
   * this value should return the query that prompted that search.
   *
   * In this generic class, full page searching is not supported.
   * This method should be implemented by subclasses that do support it.
   *
   * @see Search
   */
  getInitialSearch() {
    return '';
  }
  getValue() {
    return this.value;
  }
  setValue(value) {
    this.value = value;
  }

  /**
   * Clear the search value.
   */
  clear() {
    this.setValue('');
  }

  /**
   * Mark that we have already searched for this query so that we don't
   * have to ping the endpoint again.
   */
  cache(query) {
    this.cachedSearches.add(query);
  }

  /**
   * Check if this query has been searched before.
   */
  isCached(query) {
    return this.cachedSearches.has(query);
  }
}
flarum.reg.add('core', 'common/states/SearchState', SearchState);